import React, { useState, useEffect, useRef } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link, useNavigate } from "react-router-dom";
import { FaBan, FaCheck, FaEdit, FaFileWord, FaPlus, FaQuestionCircle, FaTimes, FaTrash } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import { BsPerson } from "react-icons/bs";
// import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Footer from "../../composant_reutilisable/footer";
// import Pas_acces from "../../composant_reutilisable/pas_acces";
import axios from "axios";
import TableauDynamique2 from "../../composant_reutilisable/tableau2";
import Sortable from "sortablejs";
import { FaClock, FaClosedCaptioning, FaRegClosedCaptioning, FaUpwork, FaWordpress } from "react-icons/fa6";

const Liste_motssensibles = () => {
    useAuth();
    const utilisateur_id = localStorage.getItem("utilisateur_id");
    const [isLoading, setIsLoading] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const navigate = useNavigate();

    useEffect(() => {
        if (user_id) {
            document.title = "ShowTime | Mots Sensibles";
        }
    }, [user_id]);

    // États
    const [userData, setUserData] = useState({});
    const [motsSensibles, setMotsSensibles] = useState([]);
    const [Liste_motssensibles, setListe_motssensibles] = useState([]);

    // États pour la recherche et la pagination
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // État pour suivre l'utilisateur sélectionné
    // const [utilisateurSelectionne, setUtilisateurSelectionne] = useState(null);


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    // Récupérer les données de l'utilisateur
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${utilisateur_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setUserData(data);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                console.error("Erreur lors de la récupération du profil:", error);
            }
        };

        fetchUserData();
    }, [utilisateur_id]);


    const recupererMots = async (ids) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-mots-selectionnes/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ ids }),  // ex: [1, 3, 7]
            });

            if (response.ok) {
                const data = await response.json();
                // Exemple: [{ id: 1, nom: "Terrorisme" }, ...]
                return data;
            } else {
                console.error("Erreur de récupération des mots");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
        }
    };



    // Récupérer la liste des utilisateurs
    const fetchMots = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-mots-sensibles/");
            if (response.ok) {
                const data = await response.json();
                setListe_motssensibles(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des utilisateurs:", error);
        }
    };

    useEffect(() => {
        fetchMots();
    }, []);

    const colonnesMotssensible = [
        //{ titre: "ID", cle: "id" },
        { titre: "Nom", cle: "nom" },
        // { titre: "Prénoms", cle: "prenoms" },
        // { titre: "Email", cle: "email" },
        // { titre: "Téléphone", cle: "tel" },
        // { titre: "Statut", cle: "statut" },
    ];

    // Filtrer les utilisateurs selon le terme de recherche
    const utilisateursFiltres = Liste_motssensibles.filter(user =>
        user.nom.toLowerCase().includes(searchTerm.toLowerCase())
        // user.prenoms.toLowerCase().includes(searchTerm.toLowerCase()) ||
        // user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        // user.tel.toLowerCase().includes(searchTerm.toLowerCase()) ||
        // user.statut.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination
    const totalItems = utilisateursFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const utilisateursAffiches = utilisateursFiltres.slice(indexOfFirstItem, indexOfLastItem);

    // const handleSelectionUtilisateur = (user) => {
    //     setUtilisateurSelectionne(user);
    // };

    // const [utilisateursSelectionnes, setUtilisateursSelectionnes] = useState([]);

    const [nouveauMot, setNouveauMot] = useState([]);


    const handleSelectionMot = (user, isSelected) => {
        setMotsSensibles(prev => {
            if (isSelected) {
                return [...prev, user];
            } else {
                return prev.filter(u => u.id !== user.id);
            }
        });
    };

    // Gestion des modal 
    const modifierMot = (index, value) => {
        const mots = [...nouveauMot];
        mots[index] = value;
        setNouveauMot(mots);
    };

    const modificationMot = (index, newNom) => {
        const updated = [...motsSensibles];
        updated[index].nom = newNom;
        setMotsSensibles(updated);
    };


    const ajouterMot = () => {
        setNouveauMot([...nouveauMot, ""]);
    };

    const supprimerMot = (index) => {
        const mots = nouveauMot.filter((_, i) => i !== index);
        setNouveauMot(mots);
    };


    // Fonction d'ajout 


    // Fonction de suppression
    const handleSupprimer = async () => {
        if (!motsSensibles) {
            console.log("❗ Aucun utilisateur sélectionné pour la suppression.");
            return;
        }

        console.log(`📤 Tentative de suppression de l'utilisateur avec l'ID : ${motsSensibles.id}`);

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-utilisateur/${motsSensibles.id}/${user_id}`, {
                method: "DELETE",
            });

            if (response.ok) {
                console.log(`✅ Utilisateur ${motsSensibles.nom} supprimé avec succès depuis le serveur.`);

                // Mise à jour de la liste des utilisateurs après suppression
                setListe_motssensibles(Liste_motssensibles.filter(u => u.id !== motsSensibles.id));
                // Réinitialisation de la sélection
                setMotsSensibles(null);
                setShowModal(false);

                // Affichage du message de confirmation
                showAlert(`Utilisateur ${motsSensibles.nom}  supprimé avec succès`, "success");

            } else {
                console.error(`❌ Erreur lors de la suppression de l'utilisateur ${motsSensibles.nom}.`);
                showAlert(`Erreur lors de la suppression de l'utilisateur ${motsSensibles.nom}.`, "danger");
            }
        } catch (error) {
            console.error("❌ Erreur réseau lors de la suppression :", error);
            showAlert("Une erreur s'est produite lors de la suppression. Veuillez réessayer.", "danger");
        } finally {
            setShowModal(false);
        }
    };


    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState(""); // Stocke le rôle sélectionné

    const handleOpenModal = () => {
        setNouveauMot([""]); // on initialise toujours avec un champ vide
        setShowModal(true);     // puis on affiche le modal
    };


    const handleCloseModal = () => {
        setShowModal(false);
        setNouveauMot([]); // Réinitialiser après fermeture
    };

    // const handleEditModal = () => {
    //     if (motsSensibles.length === 0 || motsSensibles.length > 20) return;
    //     setShowEditModal(true);
    // };

    const handleEditModal = async () => {
        if (motsSensibles.length === 0 || motsSensibles.length > 20) return;

        // Récupère les IDs (si `motsSensibles` contient des objets, ex: [{id:1, nom:"abc"}])
        const ids = motsSensibles.map(m => m.id);

        try {
            const motsRecuperes = await recupererMots(ids);  // appel à la fonction fetch

            if (motsRecuperes && motsRecuperes.length > 0) {
                setNouveauMot(motsRecuperes);  // <-- tu mets ici les valeurs dans ton état d’édition
                setShowEditModal(true);
            } else {
                showAlert("Aucun mot récupéré.", "danger");
            }
        } catch (error) {
            console.error("Erreur récupération mots:", error);
            showAlert("Erreur lors de la récupération des mots.", "danger");
        }
    };



    const handleEditCloseModal = () => {
        setShowEditModal(false);
    };

    const handleDeleteModal = () => {
        if (motsSensibles.length < 1) return;
        setShowDeleteModal(true);
    };

    const handleDeleteCloseModal = () => {
        setShowDeleteModal(false);
    };

    const handleAjouterMot = async () => {
        const nomsNonVides = nouveauMot
            .map(nom => nom.trim())
            .filter(nom => nom.length > 0);

        if (nomsNonVides.length === 0) {
            showAlert("Veuillez saisir au moins un mot sensible.", "danger");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-mots-sensibles/${user_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ noms: nomsNonVides }),  // <-- la bonne clé ici
            });

            if (response.ok) {
                await fetchMots();
                setNouveauMot([""]); // réinitialise
                handleCloseModal();
                showAlert("Mots sensibles ajoutés avec succès", "success");
            } else {
                showAlert("Erreur lors de l'ajout des mots sensibles.", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Une erreur est survenue. Veuillez réessayer.", "danger");
        }
    };

    const handleModifierMots = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-mots-sensibles/${user_id}/`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ mots: motsSensibles }),
            });

            if (response.ok) {
                showAlert("Mots modifiés avec succès", "success");
                handleEditCloseModal();
                fetchMots(); // pour rafraîchir la liste
            } else {
                showAlert("Échec de la modification des mots", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Une erreur est survenue.", "danger");
        }
    };



    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    // if (!accesGroupes.includes("Utilisateurs")) {
    //     return (
    //         <Pas_acces />
    //     );
    // }


    const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const containerRef = useRef(null);

    // Active le drag & drop
    useEffect(() => {
        if (containerRef.current) {
            Sortable.create(containerRef.current, {
                animation: 150,
                onEnd: (evt) => {
                    const newTags = [...tags];
                    const [removed] = newTags.splice(evt.oldIndex, 1);
                    newTags.splice(evt.newIndex, 0, removed);
                    setTags(newTags);
                }
            });
        }
    }, []); // pas de dépendance ici


    const addTag = () => {
        const trimmed = inputValue.trim();
        if (trimmed && !tags.includes(trimmed)) {
            setTags([...tags, trimmed]);
            setInputValue("");
        }
    };

    const removeTag = (index) => {
        const newTags = [...tags];
        newTags.splice(index, 1);
        setTags(newTags);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            addTag();
        }
    };

    // const handleSave = () => {
    //     onSave(tags); // fonction pour envoyer au backend
    //     onClose();
    // };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaBan size={25} className='mr-2' /> Mots sensibles
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'utilisateurs'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small>Administration des utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Utilisateurs
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des utilisateurs</h5>
                                <div className="d-flex flex-column flex-md-row">
                                    <button className="btn btn-success mr-2" onClick={handleOpenModal}>
                                        <FaPlus />Ajouter
                                    </button>
                                    <button
                                        onClick={handleEditModal}
                                        disabled={motsSensibles.length === 0 || motsSensibles.length > 20}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${motsSensibles.length > 0 && motsSensibles.length <= 20
                                            ? 'btn-success'
                                            : 'btn-default text-dark disabled'
                                            }`}
                                    >
                                        <FaEdit /> Modifier
                                    </button>

                                    <button
                                        onClick={handleDeleteModal}
                                        disabled={motsSensibles.length === 0}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${motsSensibles.length > 0 ? 'btn-success' : 'btn-default text-dark disabled'
                                            }`}
                                    >
                                        <FaTrash /> Supprimer
                                    </button>
                                </div>
                            </div>
                            <div className="row">

                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <TableauDynamique2
                                                colonnes={colonnesMotssensible}
                                                donnees={utilisateursFiltres}
                                                isLoading={isLoading}
                                                messageAucun="Aucun utilisateur trouvé."
                                                onSelectRow={(user, isSelected) => handleSelectionMot(user, isSelected)}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>

                    {/* Modal d'ajout  */}
                    <Modal show={showModal}>
                        <Modal.Header>
                            <Modal.Title>Ajouter les mots sensibles</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="mb-3">
                                <label>Mot sensible :</label>
                                {/* <input
                                    className="form-control "
                                    type="text"
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    placeholder="Tapez un mot et appuyez sur Entrée"
                                /> */}
                            </div>

                            {/* <div ref={containerRef} className="border rounded p-3" style={{ minHeight: "100px" }}>
                                {tags.map((tag, index) => (
                                    <span
                                        key={index}
                                        className="badge rounded-pill bg-light text-dark border me-2 mb-2"
                                        style={{ cursor: "grab", display: "inline-flex", alignItems: "center" }}
                                    >
                                        {tag}
                                        <button
                                            type="button"
                                            className="btn-close btn-close-sm ms-2"
                                            aria-label="Close"
                                            onClick={() => removeTag(index)}
                                        ></button>
                                        <FaTimes
                                        type="button"
                                            className="btn-close btn-close-sm ms-2"
                                            onClick={() => removeTag(index)}
                                            aria-label="Close"
                                        />
                                    </span>
                                ))}
                            </div> */}

                            {/* <div className="border rounded p-3" style={{ minHeight: "100px" }}>
                                {tags.map((tag, index) => (
                                    <span
                                        key={index}
                                        className="badge  bg-light text-dark border me-2 mb-2 mr-1"
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            paddingRight: "8px",
                                        }}
                                    >
                                        {tag}
                                        <FaTimes
                                            type="button"
                                            className="ms-2 close-red"
                                            onClick={() => removeTag(index)}
                                            aria-label="Close"
                                        />
                                    </span>
                                ))}
                            </div> */}

                            <div className="border rounded p-3" style={{ minHeight: "100px" }}>
                                {tags.map((tag, index) => (
                                    <span
                                        key={index}
                                        className="badge rounded bg-light text-dark border me-2 mb-1 mr-1"
                                    >
                                        {tag}
                                        <FaTimes
                                            className="ml-1 ms-2 close-red"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => removeTag(index)}
                                        />
                                    </span>
                                ))}
                                <input
                                    type="text"
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    placeholder="Tapez et appuyez sur Entrée"
                                    className="border-0 bg-transparent"
                                    style={{
                                        outline: "none",
                                        minWidth: "80px",
                                        display: "inline-block"
                                    }}
                                />
                            </div>



                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                <strong>Annuler</strong>

                            </Button>
                            <Button variant="success" onClick={handleAjouterMot}>
                                <strong>Ajouter</strong>

                            </Button>
                        </Modal.Footer>
                    </Modal>



                    {/* Modal de modification */}
                    <Modal show={showEditModal}>
                        <Modal.Header>
                            <Modal.Title>Modifier les mots sensibles</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="card p-3 wrapper wrapper-content animated fadeInRight mt-3">

                                <div className="form-group">
                                    <div className="d-flex justify-content-between mb-2">
                                        <label className="form-label">Mot(s) sensible(s) :</label>
                                        <div className="w-50">
                                            {motsSensibles.map((nom, index) => (
                                                <div key={index} className="d-flex mb-2">
                                                    <input
                                                        type="text"
                                                        className="form-control me-2"
                                                        value={nom.nom}
                                                        onChange={(e) => modificationMot(index, e.target.value)}
                                                    />
                                                    {/* {motsSensibles.length > 1 && (
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => supprimerMot(index)}
                                                        >
                                                            <FaTrash />
                                                        </button>
                                                    )} */}
                                                </div>
                                            ))}

                                            {/* <div className="text-right">
                                                {motsSensibles.length < 10 && (
                                                    <button
                                                        className="btn btn-success btn-sm mt-2"
                                                        onClick={ajouterMot}
                                                    >
                                                        <FaPlus />
                                                    </button>
                                                )}
                                            </div> */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleEditCloseModal}>
                                <strong>Annuler</strong>

                            </Button>
                            {/* <Button variant="success" onClick={handleModifierMots}>
                                <strong>Modifier</strong>

                            </Button> */}
                        </Modal.Footer>
                    </Modal>



                    {/* Modal de confirmation de suppression */}
                    <Modal show={showDeleteModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la Suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer ces mots sensibles de la base ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleDeleteCloseModal}>
                                <strong>Annuler</strong>

                            </Button>
                            <Button variant="success" onClick={handleSupprimer}>
                                <strong>Supprimer</strong>

                            </Button>
                        </Modal.Footer>
                    </Modal>

                </div>
            </div>
            {/* <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} /> */}
        </div>
    );
};

export default Liste_motssensibles;
